import "./primaryBtn.css";

type BtnInstance = {
  type?: "button" | "submit" | "reset";
  text: any;
  svgBefore?: any;
  svgAfter?: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
};

export function PrimaryButton({ btn }: { btn: BtnInstance }) {
  return (
    <button type={btn.type} onClick={btn.onClick} className="btn btn-primary" style={btn.style}>
      {btn.svgBefore && <div style={{ marginRight: 5, display: "flex" }}>{btn.svgBefore}</div>}{" "}
      {btn.text}{" "}
      {btn.svgAfter && <div style={{ marginLeft: 5, display: "flex" }}>{btn.svgAfter}</div>}
    </button>
  );
}
